export default "__VITE_ASSET__BlG1ODWU__"